export const COACHING_OPPORTUNITY_STATUSES = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
};

export const COACHING_OPPORTUNITY_STATUSES_LABELS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
};
